import { render, staticRenderFns } from "./guide-account-recovery.vue?vue&type=template&id=1c934ef6"
import script from "./guide-account-recovery.vue?vue&type=script&lang=js"
export * from "./guide-account-recovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports